import * as React from "react";
import { SportsCarouselItem } from "../SportsCarouselItem";
import { DateCarouselItem } from "../DateCarouselItem";
import { MarketCarouselItem } from "../MarketCarouselItem";
const typeMap = {
    sports: (props) => (React.createElement(SportsCarouselItem, Object.assign({}, props))),
    favorites: (props) => (React.createElement(SportsCarouselItem, Object.assign({}, props))),
    liveStream: (props) => (React.createElement(SportsCarouselItem, Object.assign({}, props))),
    allSports: (props) => (React.createElement(SportsCarouselItem, Object.assign({}, props))),
    dates: (props) => (React.createElement(DateCarouselItem, Object.assign({}, props))),
    marketGroups: (props) => (React.createElement(MarketCarouselItem, Object.assign({}, props))),
    personalized: (props) => (React.createElement(SportsCarouselItem, Object.assign({}, props)))
};
export const CarouselItem = (props) => {
    return typeMap[props.item.type](props);
};
//# sourceMappingURL=CarouselItem.js.map